import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select} from '@ngxs/store';
import { PredictorModelState } from 'src/app/state/predictor-model/predictor-model.state';
import { InteractionType } from '../../enums/interaction-type';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-paint-info-modal',
  templateUrl: './paint-info-modal.component.html',
  styleUrl: './paint-info-modal.component.scss'
})
export class PaintInfoModalComponent implements OnInit, OnDestroy {
  ngUnsubscribe: Subject<void> = new Subject();
  InteractionType = InteractionType;
  @Select(PredictorModelState.interactionType)
  interactionType$!: Observable<InteractionType>;
  interactionType: InteractionType = InteractionType.None;

  ngOnInit(): void {
    this.interactionType$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((interactionType: InteractionType) => {
        this.interactionType = interactionType;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
